import React from 'react';
import PropTypes from 'prop-types';
import SVGWrap from './SVGWrap';

const Email = ({ outlineColor, s }) => (
  <SVGWrap style={s}>
    <path
      fill={outlineColor}
      d="M243.9,21.6c-19.7,0-35.9,16-35.9,35.8v89.8H102.4c-3.3,0-6,2.7-6,6v189.1c0,3.3,2.7,6,6,6h303.5c3.3,0,5.9-2.7,6-6V153.2
	c0-3.1-2.3-5.7-5.4-6c-0.2,0-0.4,0-0.6,0H219.9V57.4c0-13.3,10.6-23.8,24-23.8h52.8l26.6,43.3c1.1,1.8,3.1,2.9,5.2,2.8h63.2
	c2,0,3.9-1.1,5-2.8l26.8-43.3h52.8c13.3,0,23.8,10.5,23.8,23.8v396.1c0,13.3-10.5,24-23.8,24H243.9c-13.3,0-24-10.6-24-24v-71.2
	c0-2.2-1.1-4.2-3-5.3s-4.1-1.1-6,0c-1.9,1.1-3,3.1-3,5.3v71.2c0,19.8,16.2,36,35.9,36h232.4c19.7,0,35.7-16.2,35.7-36V57.4
	c0-19.8-16-35.8-35.7-35.8H243.9z M310.6,33.6h98.7l-21,34.1h-56.5L310.6,33.6z M119.7,159.2h268.7L253.9,265.6L119.7,159.2z
	 M108.3,165.2L250.4,278c2.1,1.7,5.1,1.7,7.3,0l142.2-112.8v164.6L321.2,266c-1.2-1.1-2.8-1.6-4.5-1.5c-2.4,0.3-4.4,2-5,4.3
	c-0.7,2.3,0.2,4.8,2.1,6.3l75.1,61.1H119.1l75.1-61.1c2.1-1.6,2.8-4.5,1.8-7c-1-2.5-3.5-4-6.1-3.7c-1.2,0.2-2.3,0.7-3.2,1.5
	l-78.5,63.5V165.2z M5.7,196.8c-3.3,0.2-5.8,3-5.7,6.3c0.2,3.3,2.9,5.9,6.2,5.7h55.2c2.1,0,4.1-1.1,5.2-3s1.1-4.2,0-6
	c-1.1-1.9-3.1-3-5.2-3H6.2C6,196.8,5.9,196.8,5.7,196.8z M13.7,241.8c-3.3,0.3-5.7,3.2-5.4,6.6c0.3,3.3,3.2,5.7,6.5,5.4h46.7
	c2.1,0,4.1-1.1,5.2-3c1.1-1.9,1.1-4.2,0-6c-1.1-1.9-3.1-3-5.2-3H14.8C14.4,241.8,14,241.8,13.7,241.8L13.7,241.8z M24.1,286.6
	c-3.3,0.2-5.8,3-5.7,6.3c0.2,3.3,2.9,5.9,6.2,5.7h36.8c2.1,0,4.1-1.1,5.2-3s1.1-4.2,0-6s-3.1-3-5.2-3H24.6
	C24.5,286.6,24.3,286.6,24.1,286.6z M328.5,431.1c-2.1,0-4.1,1.1-5.2,3c-1.1,1.9-1.1,4.2,0,6c1.1,1.9,3.1,3,5.2,3h63.2
	c2.1,0,4.1-1.1,5.2-3c1.1-1.9,1.1-4.2,0-6c-1.1-1.9-3.1-3-5.2-3H328.5z"
    />
  </SVGWrap>
);

Email.defaultProps = {
  s: {},
  outlineColor: '#000000',
};

Email.propTypes = {
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
  }),
  outlineColor: PropTypes.string,
};

export default Email;
